/* eslint-disable camelcase */
export const ACCESS_TOKEN = 'accessToken';

export const REFRESH_TOKEN = 'refreshToken';

export const ONBOARDING_TOKEN = 'onboardingToken';

export const MARKETING_REDIRECT = 'marketingRedirect';

export const AUDIENCE_TOKEN = 'audienceToken';

// this gets set when a user authenticates but can be used by non-authenticated pages
// to display correct units when viewing profiles or reports
export const ACCOUNT_COUNTRY = 'accountCountry';

export const ROLES = 'roles';

export const SESSION_COUPON_CODE = 'session_coupon_code';

export const APPLICATIONS = {
  reps: 'reps',
  casting: 'casting',
  talent: 'talent',
  login: 'login',
  admin: 'admin',
} as const;

export type ApplicationValue = typeof APPLICATIONS[keyof typeof APPLICATIONS];

export const QUERY_PARAMS = {
  redirectAudience: 'redirectAudience',
  redirectUrl: 'redirectUrl',
  divisionId: 'division_id',
  requestType: 'requestType',
  projectIds: 'projectIds',
  slotDateTo: 'slotDateTo',
  slotDateFrom: 'slotDateFrom',
  redirectTo: 'redirectTo',
  listReport: 'listReport',
  scheduleId: 'scheduleId',
  dueDateTo: 'dueDateTo',
  dueDateFrom: 'dueDateFrom',
  couponCode: 'coupon_code',
  couponType: 'coupon_type',
  defaultAppContext: 'default_app_context',
  savedSearchId: 'savedSearchId',
  planTerm: 'plan_term',
  theme: 'theme',
  deeplink: 'deeplink',
  fbclid: 'fbclid',
};

export const OPEN_CALL_QUERY_PARAMS = {
  utm_source: 'open_call',
  utm_medium: 'social',
  utm_campaign: 'event_open_call',
} as const;

export const AUDIENCE = 'AUDIENCE';

export const TALENT_URL = 'TALENT_URL';

export const CASTING_URL = 'CASTING_URL';

export const REPS_URL = 'REPS_URL';

export const NODE_ENV = 'NODE_ENV';

export const API_URL = 'API_URL';

export const SCHEDULED_MAINTENANCE = 'b21-scheduled-maintenance-mode';

export const PRODUCTION = 'prd';

export const STAGING = 'stg';

// This variable is used to know if you are running this locally or in a unit test
export const TEST = 'test';

// Used when running the code locally, this can be used to skip third party APIs such
// as heap or braze
export const DEV = 'dev';

// This variable is used to broadcast the instagram auth code
export const INSTAGRAM_AUTH_CODE_KEY = 'instagram_auth_code';

// This variable is used to broadcast the tiktok auth code
export const TIKTOK_AUTH_CODE_KEY = 'tiktok_auth_code';

// This variable is used to store the utm_source in session storage,
// utm_source is used to show both free and premium plan for open call
export const UTM_SOURCE = 'utm_source';

// This variable is used to store the last auto-opened date for the single click reactivation modal
export const LAST_REACTIVATION_MODAL_AUTO_OPENED_DATE = 'last_reactivation_modal_auto_opened_date';
